import { render, staticRenderFns } from "./zxm_report.vue?vue&type=template&id=60d3aac4&scoped=true"
import script from "./zxm_report.vue?vue&type=script&lang=js"
export * from "./zxm_report.vue?vue&type=script&lang=js"
import style0 from "./zxm_report.vue?vue&type=style&index=0&id=60d3aac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3aac4",
  null
  
)

export default component.exports